// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"602":"e33607ba","667":"e33607ba"}[chunkId] + ".chunk.css";
};